import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: max-content;
  width: 424px;
  padding: 16px;
`;

export const ContainerChild = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const TextContainer = styled.div`
  margin-top: 4px;
`;

export const TextParagraph = styled.p`
  font-size: 12px;
  text-align: center;
  font-family: "sans-serif";
  line-height: 16px;
  font-weight: 500;
  color: #f32a00;
`;

// Same danger-token outline button as ColorPalette's transient-failure retry
// (Shared/ColorPalette/styles.js PaletteRetryButton) for visual consistency.
export const RetryButton = styled.button`
  appearance: none;
  border: 1px solid #f32a00;
  background: transparent;
  color: #f32a00;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease;
  &:hover {
    background: rgba(243, 42, 0, 0.08);
  }
  &:focus-visible {
    outline: 2px solid #f32a00;
    outline-offset: 2px;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;
